// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh5[data-v-01f0d5c4] {\n  color: var(--sea);\n  font-size: var(--01f0d5c4-fontSize);\n  font-weight: 400 !important;\n}\n.trending-icon[data-v-01f0d5c4] {\n  width: var(--01f0d5c4-trendingIconSize);\n}\n.custom-icon[data-v-01f0d5c4] {\n  width: var(--01f0d5c4-customIconSize);\n}\n", ""]);
// Exports
module.exports = exports;
